import type { PositionedItem } from '../../PageConfigProvider/types/item';

export const isMultiEntitySwitcherChart = (item: PositionedItem) => {
  const { plot } = item;
  const { chartType } = plot || {};

  return chartType === 'box';
};
